module.exports = __webpack_public_path__ + "static/media/galeryGrass1.aa4107a0.jpg";